import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { SubmissionStatus } from "../../../enums/submissionStatus";
import { RootState } from "../../../redux/store/store";

const submissionStatusesToReturnTrue = [
  SubmissionStatus.COMPLETED,
  SubmissionStatus.IN_PROGRESS,
  SubmissionStatus.ERROR,
];

export const useSubmissionIsPresent = () => {
  const { singleMedicalPaOrder } = useSelector(
    (state: RootState) => state.singleMedicalPaOrder,
  );
  const [submissionIsPresent, setSubmissionIsPresent] = useState(false);

  useEffect(() => {
    if (!singleMedicalPaOrder) {
      setSubmissionIsPresent(false);
      return;
    }
    const submissionStatus = singleMedicalPaOrder?.status?.submission;
    if (
      submissionStatus &&
      submissionStatusesToReturnTrue.includes(
        submissionStatus as SubmissionStatus,
      )
    ) {
      setSubmissionIsPresent(true);
      return;
    }
    setSubmissionIsPresent(false);
  }, [singleMedicalPaOrder]);
  return submissionIsPresent;
};
